<template>
    <div>
        <div class="col-lg-12 col-md-12 p-0">
            <div class="card">
                <div class="body">
                    <ul
                        class="nav nav-pills nav-tabs-new2 tw-overflow-x-auto tw-flex-nowrap"
                    >
                        <li class="nav-item tw-whitespace-nowrap">
                            <a
                                class="nav-link active show"
                                data-toggle="tab"
                                href="#manageData"
                                >จัดการข้อมูล</a
                            >
                        </li>
                        <li class="nav-item tw-whitespace-nowrap">
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#manageProduct"
                                >จัดการสินค้า</a
                            >
                        </li>
                        <li class="nav-item tw-whitespace-nowrap">
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#manageMenu"
                                v-if="salepage.type == 'sale'"
                                >จัดการเมนู</a
                            >
                        </li>
                        <!-- <li 
                            class="nav-item tw-whitespace-nowrap"
                            v-if="salepage.type == 'sale'"
                        >
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#manageMenuFormat"
                                >รูปแบบหน้าเมนู</a
                            >
                        </li> -->
                        <li
                            class="nav-item tw-whitespace-nowrap"
                            v-if="salepage.type == 'form'"
                        >
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#manageForm"
                                >จัดการฟอร์ม</a
                            >
                        </li>
                        <li
                            class="nav-item tw-whitespace-nowrap"
                            v-if="salepage.type == 'sale'"
                        >
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#manageTransport"
                                >ตั้งค่าขนส่ง</a
                            >
                        </li>
                        <li
                            class="nav-item tw-whitespace-nowrap"
                            v-if="salepage.type == 'sale'"
                        >
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#managePayment"
                                >ช่องทางการชำระเงิน</a
                            >
                        </li>
                        <li class="nav-item tw-whitespace-nowrap">
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#manageToken"
                                >การตลาด</a
                            >
                        </li>
                        <li class="nav-item tw-whitespace-nowrap">
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#optional"
                                >Optional</a
                            >
                        </li>
                        <li class="nav-item tw-whitespace-nowrap">
                            <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#background"
                                >Background</a
                            >
                        </li>
                    </ul>
                    <div class="tab-content px-0">
                        <div class="tab-pane show active" id="manageData">
                            <manage-salepage-body-component
                                :shop="shop"
                                :sale-page="salepage"
                            ></manage-salepage-body-component>
                        </div>
                        <div class="tab-pane" id="manageProduct">
                            <manage-product-component
                                :shop="shop"
                                :salepageId="salepage.id"
                            ></manage-product-component>
                        </div>
                        <div class="tab-pane" id="manageMenu">
                            <manage-menu-component
                                :shop="shop"
                                :salepageId="salepage.id"
                            ></manage-menu-component>
                        </div>
                        <!-- <div class="tab-pane" id="manageMenuFormat">
                            <manage-menu-format-component
                                :shop="shop"
                                :sale-page="salepage"
                            ></manage-menu-format-component>
                        </div> -->
                        <div
                            class="tab-pane"
                            id="manageForm"
                            v-if="salepage.type == 'form'"
                        >
                            <form-manage-component
                                :shop="shop"
                                :salepageId="salepage.id"
                            ></form-manage-component>
                        </div>
                        <div
                            class="tab-pane"
                            id="manageTransport"
                            v-if="salepage.type == 'sale'"
                        >
                            <manage-transport-component
                                :shop="shop"
                                :salepageId="salepage.id"
                            >
                            </manage-transport-component>
                        </div>
                        <div
                            class="tab-pane"
                            id="managePayment"
                            v-if="salepage.type == 'sale'"
                        >
                            <manage-payment-component
                                :shop="shop"
                                :sale-page="salepage"
                            ></manage-payment-component>
                        </div>
                        <div class="tab-pane" id="manageToken">
                            <token-component
                                :shop="shop"
                                :sale-page="salepage"
                            ></token-component>
                        </div>
                        <div class="tab-pane" id="optional">
                            <flash-sale-component
                                :shop="shop"
                                :sale-page="salepage"
                                :button="button[0]"
                            ></flash-sale-component>
                        </div>
                        <div class="tab-pane" id="background">
                            <background-setting-component
                                :shop="shop"
                                :sale-page="salepage"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.card {
    @media (min-width: 0px) and (max-width: 992px) {
        .body {
            padding: 20px 10px;
        }
        .tab-content {
            padding: 15px 5px;
        }
    }
}
.tabbable .nav-tabs-new2 {
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
}
.tabbable .nav-tabs-new2 .nav-item {
    white-space: nowrap;
}
.nav-pills > li > a {
    background-color: #fcfcfc;
}
.nav-tabs-new2 > li > a {
    margin-right: 0;
}
.nav-pills .nav-link {
    border-radius: 0;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: #000000;
}
</style>

<script>
export default {
    props: ["shop", "salepage", "button"],

    data() {
        return {};
    },

    created() {},

    methods: {}
};
</script>
